import { createIcon } from '@chakra-ui/icons';

export const AuthoringVideo = createIcon({
  displayName: 'AuthoringVideo',
  viewBox: '0 0 44 44',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
      <g clipPath="url(#clip0_3590_12303)">
        <path
          d="M13.5581 41.604C28.6467 48.1078 45.1177 35.8388 43.2059 19.5198C42.3179 11.9402 37.4508 5.41147 30.4405 2.39612C15.3518 -4.10769 -1.11919 8.16133 0.792655 24.4804C1.68063 32.0599 6.54771 38.5887 13.5581 41.604Z"
          fill="#F9F1E3"
        />
        <path d="M13.9922 8.33936H38.1963V30.1231H13.9922V8.33936Z" fill="white" />
        <path
          d="M13.9922 8.33936H38.1963V30.1231H13.9922V8.33936Z"
          stroke="#5D5B57"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.9648 7.73438H35.169V30.7283H10.9648V7.73438Z" fill="white" />
        <path
          d="M10.9648 7.73438H35.169V30.7283H10.9648V7.73438Z"
          stroke="#5D5B57"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5352 38.5948C13.531 39.5264 19.0752 40.1095 23.5147 39.6444C25.5784 39.4282 26.8494 39.0279 26.8474 38.5948C26.8516 37.6632 21.3074 37.0801 16.8679 37.5453C14.8041 37.7615 13.5332 38.1618 13.5352 38.5948Z"
          fill="#F1DCBA"
        />
        <path
          d="M8.4375 9.12939C8.4375 8.30097 9.10907 7.62939 9.9375 7.62939H30.1417C30.9701 7.62939 31.6417 8.30097 31.6417 9.12939V29.3336C31.6417 30.162 30.9701 30.8336 30.1417 30.8336H9.9375C9.10907 30.8336 8.4375 30.162 8.4375 29.3336V9.12939Z"
          fill="#EBB464"
          stroke="#5D5B57"
        />
        <path
          d="M32.1445 27.7026V29.5169C32.1445 30.5188 31.3322 31.3311 30.3302 31.3311H9.75564C8.75363 31.3312 7.94141 30.5189 7.94141 29.5169V27.7026H32.1445Z"
          fill="white"
          stroke="#5D5B57"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4062 29.669C10.4062 30.1003 10.8731 30.3699 11.2467 30.1542C11.42 30.0541 11.5268 29.8692 11.5268 29.669C11.5268 29.2377 11.0599 28.9682 10.6864 29.1838C10.513 29.2839 10.4062 29.4689 10.4062 29.669Z"
          fill="#5D5B57"
        />
        <path
          d="M14.0352 29.669C14.0352 30.1003 14.502 30.3699 14.8756 30.1542C15.0489 30.0541 15.1557 29.8692 15.1557 29.669C15.1557 29.2377 14.6888 28.9682 14.3153 29.1838C14.1419 29.2839 14.0352 29.4689 14.0352 29.669Z"
          fill="#5D5B57"
        />
        <path
          d="M17.668 29.669C17.668 30.1003 18.1349 30.3699 18.5084 30.1542C18.6817 30.0541 18.7886 29.8692 18.7886 29.669C18.7886 29.2377 18.3216 28.9682 17.9481 29.1838C17.7748 29.2839 17.668 29.4689 17.668 29.669Z"
          fill="#5D5B57"
        />
        <path
          d="M21.2969 29.669C21.2969 30.1003 21.7638 30.3699 22.1373 30.1542C22.3106 30.0541 22.4174 29.8692 22.4174 29.669C22.4174 29.2377 21.9505 28.9682 21.577 29.1838C21.4036 29.2839 21.2969 29.4689 21.2969 29.669Z"
          fill="#5D5B57"
        />
        <path
          d="M24.9258 29.669C24.9258 30.1003 25.3927 30.3699 25.7662 30.1542C25.9396 30.0541 26.0463 29.8692 26.0463 29.669C26.0463 29.2377 25.5794 28.9682 25.2059 29.1838C25.0325 29.2839 24.9258 29.4689 24.9258 29.669Z"
          fill="#5D5B57"
        />
        <path
          d="M28.5586 29.669C28.5586 30.1003 29.0255 30.3699 29.399 30.1542C29.5724 30.0541 29.6792 29.8692 29.6792 29.669C29.6792 29.2377 29.2123 28.9682 28.8387 29.1838C28.6654 29.2839 28.5586 29.4689 28.5586 29.669Z"
          fill="#5D5B57"
        />
        <path
          d="M23.8519 20.1205C24.3101 19.856 24.3101 19.1947 23.852 18.9301C23.8519 18.9301 23.852 18.9302 23.852 18.9301L16.5549 14.7146C16.0966 14.4503 15.5241 14.7806 15.5234 15.3095V23.7383C15.5241 24.2673 16.0966 24.5976 16.5549 24.3333L23.8519 20.1205Z"
          fill="white"
        />
        <path
          d="M23.852 18.9301C24.3101 19.1947 24.3101 19.856 23.8519 20.1205L16.5549 24.3333C16.0966 24.5976 15.5241 24.2673 15.5234 23.7383V15.3095C15.5241 14.7806 16.0966 14.4503 16.5549 14.7146L23.852 18.9301ZM23.852 18.9301C23.8519 18.9301 23.852 18.9302 23.852 18.9301Z"
          stroke="#5D5B57"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.1417 8.94465V10.7589H7.9375V8.94465C7.9375 7.94263 8.74972 7.13033 9.75173 7.13037H30.3263C31.3287 7.12981 32.1417 7.94224 32.1417 8.94465Z"
          fill="white"
          stroke="#5D5B57"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4062 9.09577C10.4062 9.5271 10.8731 9.79665 11.2467 9.58103C11.42 9.48093 11.5268 9.29597 11.5268 9.09577C11.5268 8.66448 11.0599 8.39493 10.6864 8.61055C10.513 8.71065 10.4062 8.89561 10.4062 9.09577Z"
          fill="#5D5B57"
        />
        <path
          d="M14.0352 9.09577C14.0352 9.5271 14.502 9.79665 14.8756 9.58103C15.0489 9.48093 15.1557 9.29597 15.1557 9.09577C15.1557 8.66448 14.6888 8.39493 14.3153 8.61055C14.1419 8.71065 14.0352 8.89561 14.0352 9.09577Z"
          fill="#5D5B57"
        />
        <path
          d="M17.668 9.09577C17.668 9.5271 18.1349 9.79665 18.5084 9.58103C18.6817 9.48093 18.7886 9.29597 18.7886 9.09577C18.7886 8.66448 18.3216 8.39493 17.9481 8.61055C17.7748 8.71065 17.668 8.89561 17.668 9.09577Z"
          fill="#5D5B57"
        />
        <path
          d="M21.2969 9.09577C21.2969 9.5271 21.7638 9.79665 22.1373 9.58103C22.3106 9.48093 22.4174 9.29597 22.4174 9.09577C22.4174 8.66448 21.9505 8.39493 21.577 8.61055C21.4036 8.71065 21.2969 8.89561 21.2969 9.09577Z"
          fill="#5D5B57"
        />
        <path
          d="M24.9258 9.09577C24.9258 9.5271 25.3927 9.79665 25.7662 9.58103C25.9396 9.48093 26.0463 9.29597 26.0463 9.09577C26.0463 8.66448 25.5794 8.39493 25.2059 8.61055C25.0325 8.71065 24.9258 8.89561 24.9258 9.09577Z"
          fill="#5D5B57"
        />
        <path
          d="M28.5586 9.09577C28.5586 9.5271 29.0255 9.79665 29.399 9.58103C29.5724 9.48093 29.6792 9.29597 29.6792 9.09577C29.6792 8.66448 29.2123 8.39493 28.8387 8.61055C28.6654 8.71065 28.5586 8.89561 28.5586 9.09577Z"
          fill="#5D5B57"
        />
      </g>
      <defs>
        <clipPath id="clip0_3590_12303">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
